import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { useFeature } from '../../store/hooks/useFeature';
import { Features } from '../../models/features';

export interface FeatureRouteProps extends Omit<RouteProps, 'children'> {
  whenFlag: Features;
  isEnabled?: boolean;
}

// tslint:disable-next-line:variable-name
export const FeatureRoute = ({ whenFlag, isEnabled = true, ...routeProps }: FeatureRouteProps) => {
  const { isLoading, value } = useFeature(whenFlag);

  if (isLoading) {
    return <Route {...routeProps}><></></Route>;
  }

  if (value !== isEnabled) {
    return <Route {...routeProps}>
      <Redirect to="/404" />
    </Route>;
  }

  return <Route {...routeProps} />;
};
